module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@carvana/showroom-theme"
var showroom_theme_ = __webpack_require__("@carvana/showroom-theme");

// CONCATENATED MODULE: ./src/typography.ts


var HeaderBase = external_styled_components_default.a.h1.withConfig({
  displayName: "HeaderBase",
  componentId: "sc-72be9h-0"
})(["color:", ";font-family:", ";font-weight:700;text-transform:uppercase;"], function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref$theme;
  return theme.carvana.blue.dark;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref2$theme;
  return theme.typography.fontFamily;
});
var BodyBase = external_styled_components_default.a.p.withConfig({
  displayName: "BodyBase",
  componentId: "sc-72be9h-1"
})(["color:", ";font-family:", ";font-weight:400;"], function (_ref3) {
  var _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref3$theme;
  return theme.carvana.gray.dark;
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref4$theme;
  return theme.typography.fontFamily;
});
var Link = external_styled_components_default.a.a.withConfig({
  displayName: "Link",
  componentId: "sc-72be9h-2"
})(["cursor:pointer;color:", ";font-family:", ";line-height:20px;text-decoration:none;&:hover{text-decoration:underline;}"], function (_ref5) {
  var _ref5$theme = _ref5.theme,
      theme = _ref5$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref5$theme;
  return theme.carvana.blue.primary;
}, function (_ref6) {
  var _ref6$theme = _ref6.theme,
      theme = _ref6$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref6$theme;
  return theme.typography.fontFamily;
});

// CONCATENATED MODULE: ./src/typography-mixin/typography-mixin.ts


var Typography;

(function (Typography) {
  Typography["Brand2"] = "Brand2";
  Typography["Brand3"] = "Brand3";
  Typography["Header1"] = "Header1";
  Typography["Header2"] = "Header2";
  Typography["Header3"] = "Header3";
  Typography["Header4"] = "Header4";
  Typography["Header5"] = "Header5";
  Typography["Header6"] = "Header6";
  Typography["Header7"] = "Header7";
  Typography["Header8"] = "Header8";
  Typography["Header9"] = "Header9";
  Typography["Body1"] = "Body1";
  Typography["Body2"] = "Body2";
  Typography["Body3"] = "Body3";
  Typography["Body4"] = "Body4";
  Typography["Body5"] = "Body5";
})(Typography || (Typography = {}));

var FontFamily = Object(external_styled_components_["css"])(["font-family:", ";"], function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref$theme;
  return theme.typography.fontFamily;
});
var BaseHeader = Object(external_styled_components_["css"])(["", ";font-weight:bold;color:", ";text-transform:uppercase;margin:0;"], FontFamily, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref2$theme;
  return theme.carvana.blue.dark;
});
var TextTreatments = {
  Brand2: Object(external_styled_components_["css"])(["", ";font-size:64px;line-height:60px;"], BaseHeader),
  Brand3: Object(external_styled_components_["css"])(["", ";font-size:38px;line-height:39px;"], BaseHeader),
  Header1: Object(external_styled_components_["css"])(["", ";font-size:42px;line-height:48px;"], BaseHeader),
  Header2: Object(external_styled_components_["css"])(["", ";font-size:28px;line-height:32px;"], BaseHeader),
  Header3: Object(external_styled_components_["css"])(["", ";font-size:24px;line-height:28px;"], BaseHeader),
  Header4: Object(external_styled_components_["css"])(["", ";font-size:22px;line-height:28px;"], BaseHeader),
  Header5: Object(external_styled_components_["css"])(["", ";font-size:20px;line-height:28px;"], BaseHeader),
  Header6: Object(external_styled_components_["css"])(["", ";font-size:18px;line-height:28px;"], BaseHeader),
  Header7: Object(external_styled_components_["css"])(["", ";font-size:16px;line-height:28px;"], BaseHeader),
  Header8: Object(external_styled_components_["css"])(["", ";font-size:14px;line-height:28px;"], BaseHeader),
  Header9: Object(external_styled_components_["css"])(["", ";font-size:12px;line-height:28px;"], BaseHeader),
  Body1: Object(external_styled_components_["css"])(["", ";font-size:26px;line-height:32px;font-weight:normal;color:", ";"], FontFamily, function (_ref3) {
    var _ref3$theme = _ref3.theme,
        theme = _ref3$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref3$theme;
    return theme.carvana.gray.dark;
  }),
  Body2: Object(external_styled_components_["css"])(["", ";font-size:18px;line-height:24px;font-weight:normal;color:", ";"], FontFamily, function (_ref4) {
    var _ref4$theme = _ref4.theme,
        theme = _ref4$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref4$theme;
    return theme.carvana.gray.dark;
  }),
  Body3: Object(external_styled_components_["css"])(["", ";font-size:16px;line-height:24px;font-weight:normal;color:", ";"], FontFamily, function (_ref5) {
    var _ref5$theme = _ref5.theme,
        theme = _ref5$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref5$theme;
    return theme.carvana.gray.dark;
  }),
  Body4: Object(external_styled_components_["css"])(["", ";font-size:14px;line-height:20px;font-weight:normal;color:", ";"], FontFamily, function (_ref6) {
    var _ref6$theme = _ref6.theme,
        theme = _ref6$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref6$theme;
    return theme.carvana.gray.dark;
  }),
  Body5: Object(external_styled_components_["css"])(["", ";font-size:12px;line-height:18px;font-weight:normal;color:", ";"], FontFamily, function (_ref7) {
    var _ref7$theme = _ref7.theme,
        theme = _ref7$theme === void 0 ? showroom_theme_["CarvanaThemeDeprecated"] : _ref7$theme;
    return theme.carvana.gray.dark;
  })
};
var typography = function typography(treatmentName) {
  return TextTreatments[treatmentName];
};
// CONCATENATED MODULE: ./src/breakpoints.ts

var breakpoints = {
  xs: '375px',
  sm: '768px',
  md: '1024px',
  lg: '1280px',
  xl: '1920px',
  values: {
    xs: 375,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1920
  }
};
var media = Object.keys(breakpoints.values).reduce(function (acc, label) {
  acc[label] = function (strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    return Object(external_styled_components_["css"])(["@media print,(min-width:", "px){", ";}"], breakpoints.values[label], external_styled_components_["css"].apply(void 0, [strings].concat(interpolations)));
  };

  return acc;
}, {});
var Breakpoints;

(function (Breakpoints) {
  Breakpoints["xs"] = "xs";
  Breakpoints["sm"] = "sm";
  Breakpoints["md"] = "md";
  Breakpoints["lg"] = "lg";
  Breakpoints["xl"] = "xl";
})(Breakpoints || (Breakpoints = {}));

var breakpoints_breakpoint = function breakpoint(breakpointName, cssString) {
  return Object(external_styled_components_["css"])(["@media all and (min-width:", "){", ";}"], breakpoints[breakpointName], cssString);
};


// CONCATENATED MODULE: ./src/index.ts
/* concated harmony reexport BodyBase */__webpack_require__.d(__webpack_exports__, "BodyBase", function() { return BodyBase; });
/* concated harmony reexport breakpoints */__webpack_require__.d(__webpack_exports__, "breakpoints", function() { return breakpoints; });
/* concated harmony reexport HeaderBase */__webpack_require__.d(__webpack_exports__, "HeaderBase", function() { return HeaderBase; });
/* concated harmony reexport Link */__webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* concated harmony reexport media */__webpack_require__.d(__webpack_exports__, "media", function() { return media; });
/* concated harmony reexport breakpoint */__webpack_require__.d(__webpack_exports__, "breakpoint", function() { return breakpoints_breakpoint; });
/* concated harmony reexport Breakpoints */__webpack_require__.d(__webpack_exports__, "Breakpoints", function() { return Breakpoints; });
/* concated harmony reexport typography */__webpack_require__.d(__webpack_exports__, "typography", function() { return typography; });
/* concated harmony reexport Typography */__webpack_require__.d(__webpack_exports__, "Typography", function() { return Typography; });
/* concated harmony reexport BaseHeader */__webpack_require__.d(__webpack_exports__, "BaseHeader", function() { return BaseHeader; });





/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.ts");


/***/ }),

/***/ "@carvana/showroom-theme":
/***/ (function(module, exports) {

module.exports = require("@carvana/showroom-theme");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map